import React from 'react';

const StorySection = () => {
  return (
    <section id="about" className="py-20 bg-slate-950/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Story
          </h2>
          <p className="text-xl text-gray-300 font-semibold">
            Built on Service, Faith, and Craftsmanship
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Photo of Owners */}
          <div className="order-2 lg:order-1 flex flex-col items-center">
            <div className="relative rounded-lg overflow-hidden border-2 border-gray-400/20 max-w-md">
              <img 
                src="/images/1zuhy15f_TayLord.Arms_kymiKev_pic.jpg"
                alt="Kevin and Kimberly Taylor - Owners of TayLord Arms"
                className="w-full h-auto object-cover"
              />
            </div>
            <p className="text-center text-gray-400 text-sm mt-4 italic">
              Kevin and Kimberly Taylor
            </p>
          </div>

          {/* Story Content */}
          <div className="order-1 lg:order-2">
            <div className="space-y-4 text-white leading-relaxed">
              <p>
                TayLord Arms was built on a foundation of service, faith, and respect for the craftsmanship and responsibility that comes with firearm ownership.
              </p>
              <p>
                Kevin and Kimberly Taylor, proud Lowcountry natives, have spent their lives serving others. Kevin served as a Deputy Sheriff with Dorchester County, and Kimberly dedicated nearly 30 years to the United States Navy. Their lives and values have been shaped by duty, discipline, and a steadfast love for God, family, country, and community.
              </p>
              <p>
                The vision for TayLord Arms began when they were teenagers. After years of building careers, raising a family, and serving with honor, Kevin and Kimberly are now bringing that dream to life together through a business built on integrity, precision, and genuine care for every firearm entrusted to them.
              </p>
              <p>
                TayLord Arms brings that same standard of excellence to gunsmithing through formal training, professional certifications, and federal licensing. Backed by decades of hands-on mechanical experience, we deliver work with precision, consistency, and a commitment to quality that never wavers.
              </p>
              <p>
                At TayLord Arms, customers can expect more than technical skill; they can expect honest guidance, dependable service, and craftsmanship done the right way.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default StorySection;
